export const ROUTES = {
  ROOT: '/',
  DASHBOARD: '/dashboard',
  HAZARD: {
    ROOT: '/hazard',
    DETAIL: (hazardType: string) => `/hazard/${hazardType}`,
  },
  CONVERSATION: {
    ROOT: '/conversation',
    DETAIL: (id: string) => `/conversation/${id}`,
  },
  SPACES: {
    ROOT: '/spaces',
    CONVERSATIONS: '/spaces/conversations',
    REPORTS: '/spaces/reports',
    REPORT_DETAIL: (id: string) => `/spaces/reports/${id}`,
  },
  TOOLS: {
    ROOT: '/tools',
  },
  NETWORK: {
    ROOT: '/network',
  },
  AUTH: {
    LOGIN: '/login',
    LOGOUT: '/logout',
  },
  MARKDOWN_TEST: '/markdown-test',
}
